import { useEffect, useState } from "react";
import { usePhotoImage } from "../lib/use-photo-image";

export function PriceBookThumb({
  src,
  name,
  className,
  onOpen,
  fit = "cover",
}: {
  src: string | null;
  name: string;
  className: string;
  onOpen?: (imageUrl: string) => void;
  fit?: "cover" | "contain";
}) {
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const archiveBacked = Boolean(src?.startsWith("/api/"));
  const photo = usePhotoImage(archiveBacked ? src : null);
  useEffect(() => { setFailed(false); }, [src]);
  const imageUrl = archiveBacked ? photo.imageUrl : src;
  const error = archiveBacked ? photo.error : failed ? "Couldn’t load image" : "";
  const retry = () => {
    if (archiveBacked) photo.retry();
    else { setFailed(false); setAttempt(value => value + 1); }
  };
  if (error) return <button type="button" aria-label={`Retry photo for ${name}`} title={`${error}. Click to retry.`} onClick={retry}
    className={`${className} grid place-content-center gap-1 rounded-lg bg-[var(--wash)] p-1 text-center text-[var(--ink-soft)] focus:outline-none focus:ring-2 focus:ring-[var(--accent)]`}>
    <span className="text-[10px] leading-tight">Image unavailable</span><span className="text-xs font-semibold">Retry</span>
  </button>;
  const content = !imageUrl ? (
    <span aria-label={src ? `Loading photo for ${name}` : `No photo for ${name}`} className={`${className} grid place-items-center bg-[var(--wash)] font-semibold text-[var(--ink-faint)]`}>
      {src ? <span className="text-[10px] font-normal">Loading…</span> : name.trim().charAt(0).toUpperCase()}
    </span>
  ) : (
    <img key={`${src}-${attempt}`} src={imageUrl} alt="" loading="lazy" onError={archiveBacked ? photo.onImageError : () => setFailed(true)} className={`${className} ${fit === "contain" ? "object-contain" : "object-cover"}`} />
  );
  return onOpen && imageUrl ? (
    <button type="button" aria-label={`Open photo for ${name}`} onClick={() => onOpen(imageUrl)} className="block rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--accent)]">
      {content}
    </button>
  ) : content;
}
